<template>
    <div>
        <!-- 点击 Report information errors 后弹出 -->
        <div class="deep">
            <el-dialog :visible.sync="newDialog" center :close-on-click-modal="true" @close="closeDialog"
                custom-class="dialog_normalsuo" :append-to-body="true">
                <div class="detail_cont">
                    <h3>Identify a company manually</h3>
                    <h4 class="font20 font1A2332 margin-top20">Please provide any relevant information that could
                        enhance the search results. Our data analyst will match you with the most suitable company.</h4>
                    <div class="rep_list">
                        <el-form ref="Deepform" :model="Deepform" class="report_form" :rules="rules">
                            <div class="report_item">
                                <div class="report_form_box">
                                    <div class="form_box report_form"   >
                                        <div class="fin_cont_box flex_center_between_box">
                                            <div class="fin_modu_box">
                                                <div class="fin_modu">
                                                    <el-form-item label="Company Name:" prop="CompanyName">
                                                        <el-input :placeholder="$t('MyDatabase.Entercompanyname')"
                                                            v-model="Deepform.CompanyName"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="Country:" prop="Country">
                                                        <el-select filterable v-model="Deepform.Country"
                                                            :placeholder="$t('Home.selectCountry')">
                                                            <el-option v-for="item in Coutryoptions" :key="item.val"
                                                                :label="item.value" :value="item.val">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="Registration ID:" prop="RegisterID">
                                                        <el-input placeholder="Enter Registration ID"
                                                            v-model="Deepform.RegisterID"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="Address:">
                                                        <el-input placeholder="Enter Address"
                                                            v-model="Deepform.Address"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="Other Information:" style="width: 96%;">
                                                        <el-input style="width: 100%;" v-model="Deepform.demand"
                                                            type="textarea" placeholder="Enter Information"
                                                            class="limit_box" maxlength="500"
                                                            @input="inputChange(Deepform.demand)"
                                                            show-word-limit></el-input>
                                                    </el-form-item>
                                                     <!-- <el-form-item>
                                                        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
                                                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                                                    </el-form-item> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div style="display: flex; justify-content: center">
                                    <el-button class="btn_cancel" @click="cancelReport('Deepform')">Cancel</el-button>
                                    <el-button class="btn_export" @click="onSubmitReport('Deepform')">Submit</el-button>
                                    <!-- <el-button class="btn_export" :disabled="disabledReport" @click="onSubmitReport()">Submit</el-button> -->
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { dataFeedback } from '@/api/companyApi.js';
export default {
    props: {
        showReport: {
            type: Boolean,
            default: false,
        },
        powerStatus: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            Coutryoptions: [],
            rules: {
                   CompanyName: [
                    {
                        required: true,
                        message: 'Enter company name',
                        trigger: 'blur',
                    },
                ],
                Country: [
                    { required: true, message: 'Select Country', trigger: 'change' }
                ],
                RegisterID: [

                    { required: true, message: 'Enter Registration ID', trigger: 'blur' }
                ]
            },
            // newDialog: true,
            tabName: 'Reportmycompany',
            finDialog: false,
            reportDialog2: false,

            Deepform: {
                // year: new Date().getFullYear(),
                CompanyName: '',
                Country: '',
                RegisterID: '',
                Address: '',
                demand: '',
                // coreCompetency: [],
                // businessOutlook: '',
                // uploadFiles: [],
            },
            type: '701',
            filesList: [],

            disabledReport1: true,
            disabledReport2: true,
            disabledReport: true,
           
            addReportList: [{ subject: '', demand: '' }],
        };
    },
    computed: {
        newDialog: {
            get() {
                return this.showReport;
            },
            set(newValue) { },
        },
    },

    mounted() {
        this.GetCountry();

        this.huixian();
    },
    methods: {
        GetCountry() {
            let Allcountry = JSON.parse(localStorage.getItem("countryList"))[0]
                .countryList;
            Allcountry.forEach((item) => {
                item.value = item.nameEn;
                item.val = item.countryCode;
            });
            this.Coutryoptions = Allcountry;
        },
        huixian() {
            this.Deepform.CompanyName = this.$route.query.searchname;
        },
        //关闭弹窗
        closeDialog() {

            this.Deepform.RegisterID = '',
                this.Deepform.Country = ''
            this.Deepform.demand = ''
            this.Deepform.Address = ''
            this.Deepform.CompanyName=''
            this.$emit('closeReportDialog', false);
        },

        inputChange(val) {
            val.length > 0 ? (this.disabledReport2 = false) : (this.disabledReport2 = true);
            if (this.disabledReport1 == false && this.disabledReport2 == false) {
                this.disabledReport = false;
            } else {
                this.disabledReport = true;
            }
        },
        //提交report
        onSubmitReport(formName) {
                this.$refs[formName].validate((valid) => {
                  
          if (valid) {
            this.hanldSubmitReport()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
            // this.hanldSubmitReport();
        },
        async hanldSubmitReport() {


            let obj = {
                companyId: this.Deepform.RegisterID,
                // companyId: id3a,
                companyName: this.Deepform.CompanyName,
                country: this.Deepform.Country,
                demand: this.Deepform.demand,
                address: this.Deepform.Address,
            };
            let res = await dataFeedback(obj);

            if (res.code == 200) {
                this.$message({
                    message: res.msg,
                    center: true,
                    type: 'success',
                });
                this.closeDialog();

            } else {
                this.$message({
                    message: res.msg,
                    center: true,
                    type: 'error',
                });
            }
        },
        //取消report
        cancelReport() {
            this.closeDialog();

        },
    },
};
</script>
<style scoped>
.form_box /deep/ .el-input__inner {
    width: 162px;
    height: 34px;
    line-height: 34px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e7eaed;
    font-size: 1.2857143rem;
}






.form_box /deep/ .el-select .el-icon-arrow-up:before {
    color: #8497ab !important;
}


.fin_modu.last {
    height: 661px;
}

.form_box /deep/ .el-form-item__content {
    line-height: 34px;
    margin-left: 162px;
    font-size: 1.2857143rem;
}

/deep/ .el-form-item__label {
    color: #1A2332;
    font-size: 1.2857143rem;
    margin-bottom: 10px;
}

.form_box /deep/ .el-form-item__label {
    display: flex;
    align-items: center;
    color: #1A2332;
    font-size: 1.2857143rem;
    height: 50px;
    line-height: 50px;


}

.form_box /deep/ .el-form-item {
    margin-bottom: 12px;
    display: inline-block;
    font-size: 1.2857143rem;
}


.form_box /deep/ .out_item {
    margin-bottom: 20px;
}

.form_box /deep/ .el-input__icon {
    height: auto;
}



.rep_list {
    padding-bottom: 10px;
}



.report_form_box {
    padding: 20px;
    background: #F5F5F5;
    border-radius: 6px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.report_form /deep/ .el-input__inner {
    width: 34.2857143rem;
    height: 50px;
    line-height: 50px;
}

.report_form /deep/ .el-form-item {
    margin-bottom: 20px;
}

.limit_box /deep/ .el-textarea__inner {
    height: 120px;
    width: 100%;
}

.detail_cont {}
</style>
